<template>
  <div id="inner-section-container">
    <div class="single-section">
      <div class="title-box box">
        <span>Contatti</span>
        <!-- <img src="../assets/images/plusNero.svg"> -->
        <!-- <i class="rds-icon rds-icon-plusNero"></i> -->
        <span v-if="isCurrentUser" v-on:tap="plusClicked()" class="plus">+</span>
      </div>
      <div class="description-box box" v-if="!!contacts && contacts.length">
        <div v-for="item in contacts" v-bind:key="item.key">
          <span class="item-key">{{item.key}}:</span>
          <span class="item-value" v-html="getItemValue(item)"></span>
        </div>
      </div>
    </div>
    <div class="single-section">
      <div class="title-box box">
        <span>Informazioni generali</span>
        <!-- <img src="../assets/images/plusNero.svg"> -->
        <!-- <i class="rds-icon rds-icon-plusNero"></i> -->
        <span v-if="isCurrentUser" v-on:tap="plusClicked()" class="plus">+</span>
      </div>
      <div class="description-box box" v-if="!!info && info.length">
        <div v-for="item in info" v-bind:key="item.key">
          <span class="item-key">{{item.key}}:</span>
          <span class="item-value">{{ getItemValue(item) }}</span>
        </div>
      </div>
    </div>

    <div class="single-section">
      <div class="title-box box">
        <span>Competenze</span>
        <!-- <img src="../assets/images/plusNero.svg"> -->
        <!-- <i class="rds-icon rds-icon-plusNero"></i> -->
        <span v-if="isCurrentUser" v-on:tap="plusClicked()" class="plus">+</span>
      </div>
      <div class="description-box box" v-if="!!skills && skills.length">
        <div v-for="(item, i) in skills" v-bind:key="i">{{ item }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from '../services/EventBus';
export default {
  name: 'profilecard',
  props: ['contacts', 'info', 'skills', 'isCurrentUser'],
  methods: {
    plusClicked() {
      document.getElementsByClassName('main')[0].scroll(0, 0);
      eventBus.$emit('plusButtonClicked');
    },
    getItemValue(item) {
      console.log(item);
      if (item.key === 'Data di Nascita') {
        return item.value
          .split('-')
          .reverse()
          .join('.');
      }
      return item.key !== 'Tel. Interno' ? item.value : formatInterno(item);
    }
  }
};
function formatInterno(item) {
  let intCustomInterno = item.value.slice(-3);
  let intcustomPrefix = item.value.slice(0, 2);
  let intcustomOtherPart = item.value.slice(2, 7);

  const dispayValue =
    intcustomPrefix +
    '.' +
    intcustomOtherPart +
    '.' +
    '<b>' +
    intCustomInterno +
    '</b>';
  return dispayValue;
}
</script>
<style lang="scss" scoped>
.title-box,
.description-box {
  padding: 18px;
  letter-spacing: $default-letter-spacing;
}
.description-box {
  div {
    font-size: 0.95em;
    margin-bottom: 15px;
    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
}
.plus {
  font-size: 1.5em;
}
.single-section {
  margin-bottom: 20px;
  &:nth-child(1) {
    .plus {
      display: inline-block;
    }
  }
  // .plus {
  //   display: none;
  // }
}
.item-key {
  font-weight: 500;
  margin-right: 5px;
}
</style>
